// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__PvEbc"};